/*
  diagnoses id's used in comorbidity, must correspond diagnosis in localizaton
 */

// Removed 'comorbidity.7' from this list, diabetes, added DM I and II
const comorbidity = [
  'comorbidity.1',
  'comorbidity.2',
  'comorbidity.3',
  'comorbidity.4',
  'comorbidity.5',
  'comorbidity.6',
  'comorbidity.8',
  'comorbidity.9',
  'comorbidity.10',
  'comorbidity.11',
  'comorbidity.12',
  'comorbidity.13',
  'comorbidity.14',
  'comorbidity.15',
  'comorbidity.16',
  'comorbidity.17',
  'comorbidity.18',
  'comorbidity.19',
  'comorbidity.20',
  'comorbidity.21',
  'comorbidity.22',
  'comorbidity.23',
  'comorbidity.24',
  'comorbidity.25',
  'comorbidity.26',
  'comorbidity.27',
  'comorbidity.28',
  'comorbidity.29',
  'comorbidity.30',
  'comorbidity.31',
  'comorbidity.32',
  'comorbidity.33',
  'comorbidity.34',
  'comorbidity.35',
  'comorbidity.36',
  'comorbidity.37',
  'comorbidity.38',
  'comorbidity.39',
  'comorbidity.40',
  'comorbidity.41',
  'comorbidity.42',
  'comorbidity.43',
  'comorbidity.44',
  'comorbidity.45',
  'comorbidity.46',
  'comorbidity.47',
  'comorbidity.48',
  'comorbidity.49',
  'comorbidity.50',
  'comorbidity.51',
  'comorbidity.52',
  'comorbidity.53',
  'comorbidity.54',
  'comorbidity.55',
  'comorbidity.56',
  'comorbidity.57',
];

const infection = [
  'infection.1',
  'infection.2',
  'infection.3',
  'infection.4',
  'infection.5',
  'infection.6',
  'infection.7',
  'infection.8',
  'infection.9',
  'infection.10',
  'infection.11',
  'infection.12',
  'infection.13',
  'infection.14',
  'infection.15',
  'infection.16',
  'infection.17',
  'infection.18',
  'infection.19',
  'infection.20',
  'infection.21',
  'infection.22',
  'infection.23',
  'infection.24',
  'infection.25',
  'infection.26',
  'infection.27',
  'infection.28',
  'infection.29',
  'infection.30',
];

const procedure = [
  'procedure.1',
  'procedure.2',
  'procedure.3',
  'procedure.4',
  'procedure.5',
  'procedure.6',
  'procedure.7',
  'procedure.8',
  'procedure.9',
  'procedure.10',
  'procedure.11',
  'procedure.12',
  'procedure.13',
  'procedure.14',
  'procedure.15',
  'procedure.16',
  'procedure.17',
  'procedure.18',
  'procedure.19',
  'procedure.20',
  'procedure.21',
  'procedure.22',
  'procedure.23',
  'procedure.24',
  'procedure.25',
  'procedure.26',
  'procedure.27',
  'procedure.28',
  'procedure.29',
  'procedure.30',
  'procedure.31',
  'procedure.32',
  'procedure.33',
  'procedure.34',
  'procedure.35',
  'procedure.36',
  'procedure.37',
  'procedure.38',
  'procedure.39',
  'procedure.40',
  'procedure.41',
  'procedure.42',
  'procedure.43',
  'procedure.44',
  'procedure.45',
  'procedure.46',
  'procedure.47',
  'procedure.48',
  'procedure.49',
  'procedure.50',
  'procedure.51',
  'procedure.52',
  'procedure.53',
  'procedure.54',
  'procedure.55',
  'procedure.56',
  'procedure.57',
  'procedure.58',
  'procedure.59',
  'procedure.60',
  'procedure.61',
  'procedure.62',
  'procedure.63',
  'procedure.64',
  'procedure.65',
  'procedure.66',
  'procedure.67',
  'procedure.68',
  'procedure.69',
  'procedure.70',
  'procedure.71',
  'procedure.72',
  'procedure.73',
  'procedure.74',
  'procedure.75',
  'procedure.76',
  'procedure.77',
  'procedure.78',
  'procedure.79',
  'procedure.80',
  'procedure.81',
  'procedure.82',
  'procedure.83',
  'procedure.84',
  'procedure.85',
  'procedure.86',
  'procedure.87',
  'procedure.88',
  'procedure.89',
  'procedure.90',
  'procedure.91',
  'procedure.92',
  'procedure.93',
];

const diagnoses = type =>
  type === 'comorbidity' ? comorbidity : type === 'infection' ? infection : type === 'procedure' ? procedure : null;

export default diagnoses;
